import {Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {AccountIdService, AgencyIdService} from "../../account.service";
import {CurrentRouteService} from "../../currentRoute.service";
import {ActivatedRoute} from "@angular/router";
import {ReportsService} from "../reports.service";
import { CampaignIdInterfaceData, AdgroupIdInterfaceData } from '../../shared/models/adwords.model';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

import * as _ from 'lodash';
import * as _moment from 'moment';
const moment = _moment;



/*HIGHCHARTS IMPORTS*/
//import * as Highcharts from 'highcharts';
import * as Highcharts from "highcharts/highcharts-gantt";
import ExportingModule from 'highcharts/modules/exporting';
ExportingModule(Highcharts);
import StockModule from 'highcharts/modules/stock';
StockModule(Highcharts);

import HC_exporting from 'highcharts/modules/exporting';
HC_exporting(Highcharts);

import theme from 'highcharts/themes/dark-unica';
import {interval} from "rxjs";
import {environment} from "../../../environments/environment";
theme(Highcharts);

//const ld = require("lodash");

//npm install --save lodash

//SunsetTheme(Highcharts);
Highcharts.setOptions({
  title: {
    style: {
      color: 'teal'
    }
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false
  }
});

/*HIGHLIGHTS DECLARE IMPORTS*/
declare var hljs: any;


@Component({
  selector: 'app-report-campaigns-google',
  templateUrl: './report-campaigns-google.component.html',
  styleUrls: ['./report-campaigns-google.component.css']
})
export class ReportCampaignsGoogleComponent implements OnInit, OnDestroy {

  //HIGHTCHARTS PRE
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  timeseries_object: any = [];
  hc_timeseries_list: any = [];

  agency_id: string;
  account_id: string;
  start_date: any;
  end_date: any;
  myForm: UntypedFormGroup;
  timeseries_list = [];
  adwords_accounts: any = [];
  //campaign_data: CampaignInterfaceData[] = [];
  adwords_accounts_object  = {};

  ad_name_object = {}
  ad_table_object = {}
  adgroup_chart_object = {}
  adgroup_name_object = {}
  adgroup_table_object = {}
  campaign_chart_object = {}
  campaign_name_object = {}
  campaign_table_object = {};
  campaign_status = false;
  adgroup_status = false;

  campaign_name_list:any = [];
  adgroup_name_list = [];
  adgroup_table_list = [];
  selectedCampaignId: string;
  is_data = false;

  campaign_adgroup_status:any;
  x = {}
  global_object = {}
  network: string;

  is_table_column_hidden: boolean = true;
  displayedColumns: string[] = ['date', 'impressions', 'clicks', 'conversions','conversions_all', 'cost', 'star'];
  dataSource: MatTableDataSource<CampaignIdInterfaceData>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;

  displayedColumnsAdgroup: string[] = ['date', 'impressions', 'clicks', 'conversions', 'conversions_all', 'cost', 'star'];
  dataSourceAdgroup: MatTableDataSource<AdgroupIdInterfaceData>;
  @ViewChild(MatPaginator, {static: true}) paginatorAdgroup: MatPaginator;
  @ViewChild(MatSort, {static: true}) sortAdgroup: MatSort;
  // @ViewChild(MatPaginator) paginatorAdgroup: MatPaginator;
  // @ViewChild(MatSort) sortAdgroup: MatSort;

  // displayedGoogleColumns: string[] = ['date', 'impressions', 'clicks', 'cost', 'conversions', 'star'];
  // dataSourceGoogleCampaign: MatTableDataSource<CampaignIdInterfaceData>;
  // @ViewChild(MatPaginator, {static: true}) paginatorGoogleCampaign: MatPaginator;
  // @ViewChild(MatSort, {static: true}) sortGoogleCampaign: MatSort;
  //
  // displayedColumnsGoogleAdgroup: string[] = ['date', 'impressions', 'clicks', 'cost', 'conversions', 'star'];
  // dataSourceGoogleAdgroup: MatTableDataSource<AdgroupIdInterfaceData>;
  // @ViewChild(MatPaginator, {static: true}) paginatorGoogleAdgroup: MatPaginator;
  // @ViewChild(MatSort, {static: true}) sortGoogleAdgroup: MatSort;


  network_list = [{name: "Facebook", id: 'facebook'},{name: "Googleads", id: 'googleads'}]
  is_loading = false;
  is_running = false;  //used for submit form

  constructor(
                  private cdr: ChangeDetectorRef,
                  private fb: UntypedFormBuilder,
                  private route: ActivatedRoute,
                  private reportService: ReportsService,
                  private currentrouteService: CurrentRouteService,
                  private agencyidService: AgencyIdService,
                  private accountidService: AccountIdService,) { }

  ngOnInit(): void {

    this.myForm = this.fb.group({
      start_date: [, Validators.required],
      end_date: [, Validators.required],
    })//end myForm

    this.route.params.subscribe(parms => {
      this.account_id = parms['account_id']
      //this.loadData(this.account_id)

    });

    let query_parms = this.route.snapshot.queryParamMap;
    //this.network = query_parms.get('network');
  } //end ngOnInit

  ngOnDestroy() {
    this.stopRunning()
  }
  stopRunning(){


    if (this.getPollEndpointService){
      this.getPollEndpointService.unsubscribe()
    }

    if (this.polling_subscription){
      this.polling_subscription.unsubscribe()
    }

    if (this.loadDataService){
      this.loadDataService.unsubscribe();
    }

    if (this.load_campaign_dataService){
      this.load_campaign_dataService.unsubscribe();
    }


    this.is_loading = false;
    this.is_running = false;

  }



  loadDataService: any;
  loadData(start, end) {
    this.is_loading = true;
    this.is_data = false;
    let endpoint = '';
    if (this.network=='googleads'){
      endpoint = `reports?rt=googleads&account_id=${this.account_id}&start_date=${start}&end_date=${end}&network=${this.network}`;
    }
    if (this.network=='facebook'){
      endpoint = `reports?rt=facebook&account_id=${this.account_id}&start_date=${start}&end_date=${end}&network=${this.network}`;
    }

    // let fu = this.reportService.get(endpoint).subscribe(x => {
    //   console.log('!!!!!!!!!!!!',_.isEmpty(x['body']))
    //
    //   if (_.isEmpty(x['body'])){
    //     this.is_data = true
    //   } else {
    //     for (const [cn, v] of Object.entries(x['body'])) {
    //       this.global_object[cn] = v
    //       //this.adwords_accounts.push(cn);
    //       //this.adwords_accounts_object[cn] = v;
    //     }
    //     //this.campaign_name_list = this.global_object['campaign_name_list']
    //   }
    //   this.is_loading = false;
    // },error => {
    //   console.log('ERROR ',error)
    //   this.is_loading = false;
    // }); //end apiService

    endpoint = `reports?rt=campaign_names&account_id=${this.account_id}&start_date=${start}&end_date=${end}&network=${this.network}`;
    this.loadDataService = this.reportService.get(endpoint).subscribe(x => {


      if (_.isEmpty(x['body'])){
        console.log('NO CAMPAIGN DATA')
        this.is_data = true;
        this.is_running = false;0
      } else {
        this.is_data = false;
        this.campaign_name_list = x['body'];

      }
      this.is_loading = false;
      this.is_running = false;
    },error => {
        this.is_running = false;
      //console.log('ERROR ',error)
      //this.is_loading = false;
    }
    ); //end apiService






  } //end loadData

  /*************************
    POLLING START
   ************************/

  getPollEndpointService: any;
  getPollEndpoint(report_id){

    this.is_loading = true;
    this.is_data = false;
    let endpoint = `reports?rt=poller&report_id=${report_id}`;
    this.getPollEndpointService = this.reportService.get(endpoint).subscribe(x => {


        let poll_status = x['body']['status']
        console.log('STATUS!!!!!!!!!!!!',poll_status)
        if (poll_status != 'pending'){
          console.log(x['body'])
          this.polling_subscription.unsubscribe();
          if (_.isEmpty(x['body'])) {
            this.is_data = true;
            this.is_loading = false;
          } else {
            this.is_data = false;
            this.campaign_name_list = x['body'];
            this.is_loading = false;
          } //end isEmpty
        } //end if !pending

      }, error => {
        this.is_loading = false;
        this.is_data = true;
        this.polling_subscription.unsubscribe();
      }
    )


  } // end getPollEndpoint(report_id)

  polling_subscription: any;
  pollUntillCompleted(report_id) {
    this.polling_subscription = interval(5000).subscribe(x => {
      console.log('pollUntillCompleted', x)
      this.getPollEndpoint(report_id)
    })
  } //pollUntillCompleted(report_id)

  getFacebook(start, end) {

    // CALLED FROM SUBMIT
    let endpoint = '';
    if (this.network=='facebook'){
      let endpoint = `reports?rt=facebook&account_id=${this.account_id}&start_date=${start}&end_date=${end}&network=${this.network}&worker=true`;
    }
    let fu = this.reportService.get(endpoint).subscribe(x => {
      console.log('getPollEndpoing!!!!!!!!!!!!!!!!!!!!!!!', x['body']['status'])
      let report_id = x['body']['report_id']
      this.pollUntillCompleted(report_id)
    })
  } //getLastClickSales(start, end)







  addDateEvent(type, event) {

    this.is_data = false;
    this.campaign_name_list = [];
    this.adgroup_name_list = [];
    this.hc_timeseries_list = [];
    this.timeseries_list = [];
    this.adgroup_table_list = [];

    // let start_date;
    // let end_date;
    //
    // if (type='start'){
    //   start_date = moment(event.value);
    //   this.start_date = start_date.format('YYYY-MM-DD');
    //
    // }
    // if (type='end'){
    //   end_date = moment(event.value);
    //   this.end_date = end_date.format('YYYY-MM-DD');
    // }
    // if (this.start_date && this.end_date){
    //   console.log('OMG!!!!!!',this.start_date,this.end_date)
    // }


  } //end addDateEvent

  selectEventNetwork(event){
    this.network = event.value;

    //reset all
    this.is_data = false;
    this.campaign_name_list = [];
    this.adgroup_name_list = [];
    this.hc_timeseries_list = [];
    this.timeseries_list = [];
    this.adgroup_table_list = [];

  }

  selectEventAdgroup(event) {

    if (this.network=='googleads'){
      let status = this.x['campaign_adgroup_status'][event.value]
      if (status=='ENABLED'){
        this.adgroup_status = true;
      } else {
        this.adgroup_status = false;
      }
    }



    this.adgroup_table_list = [];

    //let vv: CampaignInterfaceData[] = this.adwords_accounts_object[event.value];

    let vv: AdgroupIdInterfaceData[] = this.global_object['adgroup_table_object'][this.selectedCampaignId][event.value]

    this.adgroup_table_list = vv;
    this.dataSourceAdgroup = new MatTableDataSource(this.adgroup_table_list);
    this.dataSourceAdgroup.paginator = this.paginatorAdgroup;
    this.dataSourceAdgroup.sort = this.sortAdgroup;
  } //end selectEventAdgroup

  getTotalMetricsCampaign(metric) {

    let metric_value = this.timeseries_list.map(t => t[metric]).reduce((acc, value) => acc + value, 0);
    return metric_value

  } // getTotalMetricsAdGroup(metric)

  getTotalMetricsAdGroup(metric) {

    let metric_value = this.adgroup_table_list.map(t => t[metric]).reduce((acc, value) => acc + value, 0);
    return metric_value

  } // getTotalMetricsAdGroup(metric)

  load_campaign_dataService: any;
  load_campaign_data(campaign_id){

    this.global_object = {}
    this.x = {}

    let start_date = this.myForm.value['start_date']
    start_date = moment(start_date);
    start_date = start_date.format('YYYY-MM-DD');

    let end_date = this.myForm.value['end_date']
    end_date = moment(end_date);
    end_date = end_date.format('YYYY-MM-DD');

    this.is_loading = true;
    this.is_data = false;
    let endpoint = '';
    if (this.network=='googleads'){
      endpoint = `reports?rt=googleads&account_id=${this.account_id}&start_date=${start_date}&end_date=${end_date}&network=${this.network}&campaign_id=${campaign_id}`;
    }
    if (this.network=='facebook'){
      endpoint = `reports?rt=facebook&account_id=${this.account_id}&start_date=${start_date}&end_date=${end_date}&network=${this.network}&campaign_id=${campaign_id}`;
    }

    this.load_campaign_dataService = this.reportService.get(endpoint).subscribe(x => {
      //console.log(x['body'])

      this.x = x['body']
      this.campaign_adgroup_status = x['body']['campaign_adgroup_status']
      if (_.isEmpty(x['body'])){
        this.is_data = true
      } else {
        for (const [cn, v] of Object.entries(x['body'])) {
          this.global_object[cn] = v
        }
        this.display_data(campaign_id)

        if (this.network=='googleads'){
          let status = this.x['campaign_adgroup_status'][campaign_id]
          if (status=='ENABLED'){
            this.campaign_status = true;
          } else {
            this.campaign_status = false;
          }
        }
      }
      this.is_loading = false;
      this.is_running = false;
    },error => {
      this.is_loading = false;
      this.is_running = false;
    }); //end apiService


  } //end load_campoaign_data

  display_data(campaign_id){

    /*
     BE VERY CAREFUL CAMPAIGN'IDS IDS ARE INT FOR GOOGLE AND STRING FOR FACEBOOK!!!!!!!!
     */

    this.hc_timeseries_list = [];
    this.adgroup_name_list = [];
    this.selectedCampaignId = campaign_id;
    //When we change the campaign rebuild the adgroups list

    let adgroupids = Object.keys(this.global_object['adgroup_table_object'][campaign_id])

    for (var _i = 0; _i < adgroupids.length; _i++) {
      let adgroup_id = adgroupids[_i];
      this.adgroup_name_list.push({name: this.global_object['adgroup_name_object'][adgroup_id], id: adgroup_id})
    }

    this.timeseries_list = [];
    this.adgroup_table_list = [];

    //let vv: CampaignInterfaceData[] = this.adwords_accounts_object[event.value];

    let vv: CampaignIdInterfaceData[] = this.global_object['campaign_table_object'][campaign_id]

    // for (var _i = 0; _i < vv.length; _i++) {
    //   console.log('-----',vv[_i].campaign_name)
    // }

    this.timeseries_list = vv;
    this.dataSource = new MatTableDataSource(this.timeseries_list);
    this.cdr.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    let v = this.global_object["campaign_chart_object"][campaign_id];
    let data_impressions = [];
    let data_clicks = [];
    let data_spend = [];
    let campaign_name = this.global_object["campaign_name_object"][campaign_id];

    for (var _i = 0; _i < v.length; _i++) {
          let ts = v[_i][0]
          let imps = v[_i][1]
          let clicks = v[_i][2]
          let spend = v[_i][3]
          data_impressions.push([ts, imps])
          data_clicks.push([ts, clicks])
          data_spend.push([ts, spend])
    }

    this.timeseriesChart(campaign_name,data_impressions,data_clicks,data_spend)



  } //end dislay_data

  selectEventCampaign(event) {

    // WE JUST SELECTED THE NETWORK, DATE RANGE NOW LETS LOAD THE
    // CAMPAIGN AND ADGROUP DATA BASED ON CAMPAIGN ID
    // WE HAD BACK END ERRORS SELECTED ALL CAMPAIGNS BECUASE THE
    // PAYLOAD SIZE WAS TOO BIG FOR LARGE DATE RANGES
    this.is_running = true;
    this.hc_timeseries_list = [];
    this.adgroup_name_list = [];
    this.timeseries_list = [];
    this.adgroup_table_list = []
    let campaign_id = event.value;
    this.load_campaign_data(campaign_id)
  } //end selectEvent

  getTableRecord(row) {
  } // end getTableRecord( )

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } // applyFilter

  onSubmit() {

    this.is_running = true;
    this.hc_timeseries_list = [];
    this.adgroup_name_list = [];
    this.timeseries_list = [];
    this.adgroup_table_list = [];

    this.is_data = false;

    let start_date = this.myForm.value['start_date']
    start_date = moment(start_date);
    start_date = start_date.format('YYYY-MM-DD');

    let end_date = this.myForm.value['end_date']
    end_date = moment(end_date);
    end_date = end_date.format('YYYY-MM-DD');

    this.loadData(start_date, end_date)

    // if (environment['environment']=='local'){
    //   this.loadData(start_date, end_date)
    // } else if (this.network=='facebook' && environment['environment']!='local') {
    //   this.getFacebook(start_date, end_date)
    // } else {
    //   this.loadData(start_date, end_date)
    // }


  } //end onSubmit

  timeseriesChart(campaign_name,data_impressions,data_clicks,data_spend) {


    let temp_chart_holding = {

      hcOptions: {

        chart: {
          zoomType: 'xy'
        },
        title: {
          text: `Impressions, Clicks, Spend - ${campaign_name}`,
          align: 'left'
        },
        xAxis: [{
          type: 'datetime',
          crosshair: true
        }],
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[2]
            }
          },
          title: {
            text: 'Spend',
            style: {
              color: Highcharts.getOptions().colors[2]
            }
          },
          opposite: true

        }, { // Secondary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Impressions',
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          }

        }, { // Tertiary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Clicks',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 80,
          verticalAlign: 'top',
          y: 55,
          floating: true,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || // theme
            'rgba(255,255,255,0.25)'
        },
        series: [{
          name: 'Impressions',
          type: 'column',
          yAxis: 1,
          data: data_impressions

        }, {
          name: 'Clicks',
          type: 'spline',
          yAxis: 2,
          data: data_clicks,
          marker: {
            enabled: false
          },
          dashStyle: 'shortdot',
        }, {
          name: 'Spend',
          type: 'spline',
          data: data_spend
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                floating: false,
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                x: 0,
                y: 0
              },
              yAxis: [{
                labels: {
                  align: 'right',
                  x: 0,
                  y: -6
                },
                showLastLabel: false
              }, {
                labels: {
                  align: 'left',
                  x: 0,
                  y: -6
                },
                showLastLabel: false
              }, {
                visible: false
              }]
            }
          }]
        }

      } as Highcharts.Options,
      hcCallback: (chart: Highcharts.Chart) => { }


    } //end temp_chart_holding

    this.hc_timeseries_list.push(temp_chart_holding)

  } //end timeseriesChart

} //end class
